"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const Box = (props) => {
    const { className, item, component, componentProps, breakpoints } = props;
    return (react_1.default.createElement(styles_1.StyledBox, Object.assign({ onClick: props.onClick }, props, componentProps, { breakpoints: breakpoints
            ? breakpoints
            : {
                sm: '',
                md: '',
                lg: '',
                xl: ''
            }, className: `${className} ${item ? 'lp-box-item' : ''}` }, (component && {
        as: component
    }))));
};
exports.default = Box;
